export default function getFormatedChatMessageEvent(
  eventTemplate: string,
  name: string
) {
  return eventTemplate.replace('{name}', name)
}
